import { NavLink } from "react-router-dom";
import useBreadcrumbs, { BreadcrumbsRoute } from "use-react-router-breadcrumbs";
import { breadcrumbsStyles } from "./BreadcrumbsStyles";
import { Typography } from "@material-ui/core";
import RightArrow from "icons/RightArrow.svg";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { useStore } from "store/StoreConfigs";
import { observer } from "mobx-react";
import ContentLoader from "react-content-loader";

const Loader = () => {
    return (
        <ContentLoader
            speed={2}
            width={150}
            height={20}
            viewBox="0 0 150 20"
            backgroundColor="#f3f3f3"
            foregroundColor="#ecebeb"
        >
            <rect x="0" y="0" rx="2" ry="2" width="150" height="20" />
        </ContentLoader>
    );
};

const DynamicLaneBreadcrumb = observer(({ match }: any) => {
    const { globalViewStore, routeViewStore, shipmentViewStore } = useStore();
    const laneName =
        globalViewStore.selectedLaneName ||
        routeViewStore.laneName ||
        shipmentViewStore.laneName;

    if (!laneName) {
        return <Loader />;
    }

    return (
        <span>
            <span style={{ fontWeight: 600 }}>Lane:</span> {laneName}
        </span>
    );
});

const DynamicShipmentBreadcrumb = ({ match }: any) => {
    return (
        <span>
            <span style={{ fontWeight: 600 }}>Shipment:</span>{" "}
            {match.params.shipmentId}
        </span>
    );
};

const DynamicRouteBreadcrumb = observer(({ match }: any) => {
    const { routeViewStore, shipmentViewStore } = useStore();

    const routeName = routeViewStore.routeName || shipmentViewStore.routeName;

    if (!routeName) {
        return <Loader />;
    }

    return (
        <span>
            <span style={{ fontWeight: 600 }}>Route:</span> {routeName}
        </span>
    );
});

const DynamicDeliveryBreadcrumb = ({ match }: any) => {
    return (
        <span>
            <span style={{ fontWeight: 600 }}>Delivery </span>#:{" "}
            {match.params.deliveryId}
        </span>
    );
};

const DynamicEventBreadcrumb = ({ match }: any) => {
    return <span>TE{match.params.eventId}</span>;
};

const routes: BreadcrumbsRoute[] = [
    { path: "/", breadcrumb: null },
    { path: "/content", breadcrumb: null },
    { path: "/lrm", breadcrumb: "Global View" },
    { path: "/thor", breadcrumb: "Excursion Impact Evaluation" },
    { path: "/thor/search/:deliveryId", breadcrumb: DynamicDeliveryBreadcrumb },
    {
        path: "/thor/eventDetails/:eventId",
        breadcrumb: DynamicEventBreadcrumb,
    },
    {
        path: "/thor/eventDetails",
        breadcrumb: null,
    },
    { path: "/lrm/lanes", breadcrumb: null },
    { path: "/lrm/lanes/:laneId", breadcrumb: DynamicLaneBreadcrumb },
    { path: "/lrm/lanes/:laneId/routes", breadcrumb: null },

    {
        path: "/lrm/lanes/:laneId/routes/:routeId",
        breadcrumb: DynamicRouteBreadcrumb,
    },

    { path: "/lrm/lanes/:laneId/routes/:routeId/shipments", breadcrumb: null },

    {
        path: "/lrm/lanes/:laneId/routes/:routeId/shipments/:shipmentId",
        breadcrumb: DynamicShipmentBreadcrumb,
    },
];

export const DynamicBreadCrumbs = () => {
    const breadcrumbs = useBreadcrumbs(routes);
    const classes = breadcrumbsStyles();

    return (
        <>
            <Breadcrumbs
                separator={<img src={RightArrow} alt="arrow" />}
                aria-label="breadcrumb"
            >
                {breadcrumbs.map(({ match, breadcrumb }) => (
                    <Typography key={match.url}>
                        <NavLink
                            className={classes.breadcrumbText}
                            to={match.url}
                        >
                            {breadcrumb}
                        </NavLink>
                    </Typography>
                ))}
            </Breadcrumbs>
        </>
    );
};
